/* Styles */
import '@/scss/main.scss'
import '@/css/themes.css'
import '@/css/themes-variables.css'

/* Core */
import Vue from 'vue'
import Buefy from 'buefy'
import VueApexCharts from 'vue-apexcharts'
import VueI18n from 'vue-i18n'

/* Router & Store */
import router from './router'
import store from './store'

/* Vue. Main component */
import App from './App.vue'

/* i18n language files */
import es from './lang/es'
import cat from './lang/cat'

/* Default title tag */
const defaultDocumentTitle = 'XperienceIQ'

/* Collapse mobile aside menu on route change & set document title from route meta */
router.afterEach((to) => {
  store.commit('asideMobileStateToggle', false)
  store.dispatch('asideDesktopOnlyToggle', false)

  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} — ${defaultDocumentTitle}`
  } else {
    document.title = defaultDocumentTitle
  }
})

Vue.config.productionTip = false

// Configure vue-i18n
Vue.use(VueI18n)

// Get saved language from localStorage or default to 'es'
const savedLanguage = localStorage.getItem('userLanguage') || 'es'

const i18n = new VueI18n({
  locale: savedLanguage, // Use saved language or default
  fallbackLocale: 'es',
  messages: {
    es: es.es,
    ca: cat.cat
  }
})

// Make i18n available globally for store mutations
window.i18n = i18n

// Registrar Vue ApexCharts
Vue.use(VueApexCharts)
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Apexchart', VueApexCharts)

Vue.use(Buefy)

new Vue({
  router,
  store,
  i18n,
  mounted () {
    // Initialize store from localStorage
    store.dispatch('initializeStore')
  },
  render: (h) => h(App)
}).$mount('#app')
